import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const UPLOAD_SINGLE_FILE_DIALOG_NAME = 'UploadSingleFileDialog';
export const UPLOAD_SINGLE_FILE_DIALOG_SLOTS: Array<
	keyof UploadSingleFileDialogClasses
> = ['root'] as const;

export type UploadSingleFileDialogSlot =
	(typeof UPLOAD_SINGLE_FILE_DIALOG_SLOTS)[number];

export interface UploadSingleFileDialogClasses {
	root: string;
}

export type UploadSingleFileDialogClassKey =
	keyof UploadSingleFileDialogClasses;

export const getUploadSingleFileDialogUtilityClass = (slot: string) =>
	generateUtilityClass(
		UPLOAD_SINGLE_FILE_DIALOG_NAME,
		slot as UploadSingleFileDialogSlot,
	);

export const uploadSingleFileDialogClasses: UploadSingleFileDialogClasses =
	generateUtilityClasses(UPLOAD_SINGLE_FILE_DIALOG_NAME, ['root']);

export default uploadSingleFileDialogClasses;
